export function parseNeverDef() {
    return {
        not: {},
    };
}
//# sourceMappingURL=never.mjs.map